import { SegmentButton } from '@ipfabric/ui-components/SegmentedButton/SegmentButton/SegmentButton';
import { SegmentedButton } from '@ipfabric/ui-components/SegmentedButton/SegmentedButton';
import type { TableColumnConfig } from '@ipfabric/utils';
import { execWithArgs } from '@ipfabric/utils/fp/function';
import { prop } from '@ipfabric/utils/fp/prop';
import { makeIsColumnSticky } from 'components/Table/helpers/makeIsColumnSticky';
import { useTableContextSelectors } from 'components/Table/model/TableModel';
import { changeTableColumnSticky } from 'components/Table/model/commands/changeTableColumnSticky';
import { selectStickyColumnsSettings } from 'components/Table/model/selectors/selectStickyColumnsSettings';
import { flow } from 'fp-ts/function';
import type { FC } from 'react';

interface Props {
  className?: string;
  column: TableColumnConfig;
}

const stickyValue = 'sticky';

export const TableSettingsColumnStickyToggle: FC<Props> = (props) => {
  const ctxProps = useTableContextSelectors({
    sticky: flow(
      selectStickyColumnsSettings,
      makeIsColumnSticky,
      execWithArgs(props.column),
    ),
    dispatch: prop('dispatch'),
  });

  return (
    <SegmentedButton.Multi
      variant='plain'
      value={ctxProps.sticky ? [stickyValue] : []}
      onChange={(value) => {
        ctxProps.dispatch(changeTableColumnSticky, {
          columnKey: props.column.key,
          value: value.includes(stickyValue),
        });
      }}
    >
      <SegmentButton
        icon='fa-thumbtack'
        iconStyle={ctxProps.sticky ? 'solid' : 'regular'}
        value={stickyValue}
      />
    </SegmentedButton.Multi>
  );
};
